/**
 * @Description: 用于存储用户的标签打印记录相关接口
 */
import { ContentType, Method } from 'axios-mapper'
import https from '@/utils/https'
import { RootObject } from '@/model/rootObject'
import { PageRespModel } from '@/model/pageRespModel'
import { Route } from '@/constant/route'
import {
  LabelHistoryModel,
  LabelHistorySearchModel,
  LabelHistoryPageSearchModel,
  LabelHistoryAddModel,
  LabelHistoryUpdateModel,
  IdsModel
} from '@/model/product/LabelHistoryModel'

const baseUrl = Route.product + '/labelHistory'

/**
 * 搜索分页数据
 */
export const pageSearchLabelHistory = (param: LabelHistoryPageSearchModel) => {
  return https().request<RootObject<PageRespModel<LabelHistoryModel>>>(baseUrl.concat('/list'), Method.POST, param, ContentType.json)
}

/**
 * 搜索所有数据
 */
export const searchLabelHistory = (param: LabelHistorySearchModel) => {
  return https().request<RootObject<LabelHistoryModel[]>>(baseUrl.concat('/list/all'), Method.POST, param, ContentType.json)
}

/**
 * 根据ID查找数据
 */
export const getLabelHistory = (id: number) => {
  return https().request<RootObject<LabelHistoryModel>>(baseUrl.concat('/get/').concat(id.toString()), Method.GET, undefined, ContentType.json)
}

/**
 * 添加数据
 */
export const addLabelHistory = (param: LabelHistoryAddModel) => {
  return https().request<RootObject<any>>(baseUrl.concat('/add'), Method.POST, param, ContentType.json)
}

/**
 * 更新数据
 */
export const updateLabelHistory = (param: LabelHistoryUpdateModel) => {
  return https().request<RootObject<any>>(baseUrl.concat('/update'), Method.POST, param, ContentType.json)
}

/**
 * 删除数据
 */
export const removeLabelHistory = (id: number) => {
  return https().request<RootObject<any>>(baseUrl.concat('/remove/').concat(id.toString()), Method.POST, undefined, ContentType.json)
}

/**
 * 批量删除数据
 */
export const batchRemoveLabelHistory = (param: IdsModel) => {
  return https().request<RootObject<any>>(baseUrl.concat('/batch/remove'), Method.POST, param, ContentType.json)
}
